import { Component, Input } from '@angular/core';
import { GTMService } from 'src/app/services/gtm.service';

@Component({
  selector: 'invitation-link',
  providers: [GTMService],
  styleUrls: ['./invitation-link.component.scss'],
  template: `
    <div class="invitation-card">
      <overlay-loading *ngIf="loading"></overlay-loading>

      <div class="title">Copie o link e compartilhe</div>

      <div class="share-content">
        <span>{{originalLink}}</span>

        <button
          [class.active]="copied"
          [copy-clipboard]="inviteLink"
          (copied)="onCopy()"
        >
            {{ copied ? 'copiado' : 'copiar' }}
        </button>
      </div>

      <button class="share-btn" (click)="share()">Whatsapp</button>
    </div>
  `
})

export class InvitationLinkComponent {
  @Input()
  set link(link: string) {
    this.originalLink = link;
    this.inviteLink = /(http(s?)):\/\//i.test(link) ? link : `https://${link}`;
  }

  @Input()
  loading: boolean;

  @Input()
  voucherActive: boolean;

  @Input()
  voucherProvider: any = {};

  copied = false;

  originalLink: string;
  inviteLink: string;

  constructor(
    private gtm: GTMService
  ) { }

  onCopy() {
    this.copied = true;

    this.gtm.interaction('allya:mgm', 'mgm:click', 'copiar-url');

    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }

  share() {
    const textToShare = this.voucherActive
      ? `Eu tenho um convite e um presentinho para você! Cadastre-se na Allya para fazer seu salário render mais e ganhe R$ ${this.voucherProvider.amount} para gastar como quiser no ${this.voucherProvider.name}.\n\nÉ só clicar no link.\n${this.inviteLink}`
      : `Eu tenho um convite especial para você! Cadastre-se em Allya para fazer seu salário render mais! Descontos incríveis em mais de 30 mil estabelecimentos, físicos e on-line.\n\nÉ só clicar no link.\n${this.inviteLink}`;

    this.gtm.interaction('allya:mgm', 'mgm:click', 'compartilhar:whatsapp');

    window.open(`https://wa.me/?text=${encodeURIComponent(textToShare)}`, '_blank');
  }
}
